import axios from 'axios'
import request_url from './request_url'
import utils, { cookieSet } from '../utils/util'
import Toast from '@/common/Toast/Toast'

let query = {
    p: 'web',
    tk: '',
    v: '3.1.0',
    // sh: 667,
    // sw: 375,
    // mt: 'iPhone 6',
    // sh: 642,
    // sw: 375,
    // mt:"iPhone X",
    // lng: 116.44355,
    // lat:  39.9219,
    // tid: 1563703823481392921,
}

let excludes = [
    'mobileLoginH5',
    'getMobileLoginIdentifyCode',
    'productDetail',
    'fullCouponList',
    'getInviteUserInfo',
    'getCDNFormat',
    'userAgreement',
    'getMaterialDetail',
    'getRecommendMaterial',
    'getWeixinTicket'
]

const goLogin = () => {
    let host = window.location.origin
    let pathname = window.location.pathname
    let search = window.location.search
    cookieSet('accessToken', '')
    location.href = `${host}/login?ret=${encodeURIComponent(pathname + (search ? search : ''))}`
}
const env = process.env.NODE_ENV || 'development'

export const GET = (urlkey, params = {}) => {
    // isHideLoading 为true不显示，为false显示
    if (!params.isHideLoading) {
        Toast.showLoading()
    }
    // query.tk = decodeURIComponent(utils.cookieGet('accessToken') || '')
    query.tk = decodeURIComponent(sessionStorage.getItem("accessToken") || utils.cookieGet('accessToken') || '')
    query.p = sessionStorage.getItem("source") || query.p
    query.v = sessionStorage.getItem("version") || query.v
    query.business = sessionStorage.getItem("source") === 'dyapp' ? "tiktok" : null //api order依赖 business
    query.source =  sessionStorage.getItem("xxSource") ? sessionStorage.getItem("xxSource") : null
    // if (!excludes.includes(urlkey) && (!query.tk || (sessionStorage.getItem('business') || utils.cookieGet('business')) !== 'mryt')) {
    //     goLogin()
    //     return new Promise((resolve, reject) => { reject('登陆验证失败') })
    // }
    let url = request_url[urlkey]
    if (!params) {
        params = {}
    }
    if (urlkey === 'login') {
        query = {}
    }
    let headers = {
        "content-type": "application/json",
        "platform": "web"
    }
    return new Promise((resolve, reject) => {
        axios({
            url,
            headers,
            params: { ...query, ...params },
            method: 'get',
            timeout: 15000
        }).then(res => {
            Toast.closeLoading()
            if (res.data.code !== 0) {
                if (res.data.code === 102) {
                    // utils.cookieSet('accessToken', null)
                    // let host = window.location.origin
                    // let pathName = window.location.pathname
                    // let search = window.location.search
                    // utils.cookieSet("accessTime", 0)
                    // cookieSet('accessToken', '')
                    // location.href = `${host}/login?ret=${encodeURIComponent(pathName + (search ? search : ''))}`
                    cookieSet('accessToken', '')
                    goLogin()
                } else {
                    Toast.info(res.data.msg)
                    reject(res.data)
                }
            } else {
                resolve(res.data)
            }
            // if (env === 'development') {
                console.group('调用网络接口成功');
                console.log('[请求的Url]:', url);
                console.log('[请求的Data]:', params);
                console.log('[请求的Result]:', res.data);
                console.groupEnd();
            // }
        }).catch(error => {
            Toast.closeLoading()
            let isTimeout = JSON.stringify(error).includes('timeout') || ''
            if (isTimeout) {
                Toast.info('请求超时')
            } else {
                Toast.info(error.data.msg)
                resolve(error)
            }
            // Toast({
            //   message: '系统错误',
            //   position: "middle",
            //   duration: 1500
            // })
        })
    })
}
export const POST = (urlkey, data = {}) => {
    // isHideLoading 为true不显示，为false显示
    if (!data.isHideLoading) {
        Toast.showLoading()
    }

    // query.tk = decodeURIComponent(utils.cookieGet('accessToken') || '')
    query.tk = decodeURIComponent(sessionStorage.getItem("accessToken") || utils.cookieGet('accessToken') || '')
    query.p = sessionStorage.getItem("source") || query.p
    query.v = sessionStorage.getItem("version") || query.v
    query.business = sessionStorage.getItem("source") === 'dyapp' ? "tiktok" : null
    query.source = sessionStorage.getItem("xxSource") ? sessionStorage.getItem("xxSource") : null
    // if (!excludes.includes(urlkey) && (!query.tk || (sessionStorage.getItem('business') || utils.cookieGet('business')) !== 'mryt')) {
    //     goLogin()
    //     return new Promise((resolve, reject) => { reject('登陆验证失败') })
    // }
    let url = request_url[urlkey]
    if (!data) {
        data = {}
    }
    let headers = {
        "content-type": "application/json",
        "platform": "web"
    }
    return new Promise((resolve, reject) => {
        axios({
            url,
            data,
            headers,
            params: query,
            method: 'post',
            timeout: 15000
        }).then(res => {
            Toast.closeLoading()
            if (res.data.code !== 0) {
                if (res.data.code === 102) {
                    // utils.cookieSet('accessToken', null)
                    // let host = window.location.origin
                    // let pathName = window.location.pathname
                    // let search = window.location.search
                    // utils.cookieSet("accessTime", 0)

                    // location.href = `${host}/login?ret=${encodeURIComponent(pathName + (search ? search : ''))}`
                    cookieSet('accessToken', '')
                    goLogin()
                } else {
                    Toast.info(res.data.msg)
                    reject(res.data)
                }
            } else {
                resolve(res.data)
            }
            // if (env === 'development') {
                console.group('调用网络接口成功');
                console.log('[请求的Url]:', url);
                console.log('[请求的Data]:', data);
                console.log('[请求的Result]:', res.data);
                console.groupEnd();
            // }
        }).catch(error => {
            Toast.closeLoading()
            let isTimeout = JSON.stringify(error).includes('timeout') || ''
            if (isTimeout) {
                Toast.info('请求超时')
            } else {
                Toast.info(error.data.msg)
                resolve(error)
            }
        })
    })
}

export default {
    GET,
    POST,
    query
}



// WEBPACK FOOTER //
// ./src/api/axios.js